// Copyright © 2021 Move Closer
import { TileSize } from '../_components/ui';
import { Breakpoint, TileVersion } from './Tile.contracts';
/**
 * Registry that binds the `TileSize` with the space in the grid it requires to render properly;
 * divided by different breakpoints.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const tileSizeSpaceRegistry = {
    [TileSize.S]: {
        [Breakpoint.XS]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Breakpoint.MD]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Breakpoint.LG]: {
            colSpan: 2,
            rowSpan: 2
        }
    },
    [TileSize.L]: {
        [Breakpoint.XS]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Breakpoint.MD]: {
            colSpan: 2,
            rowSpan: 2
        },
        [Breakpoint.LG]: {
            colSpan: 3,
            rowSpan: 3
        }
    },
    [TileSize.XL]: {
        [Breakpoint.XS]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Breakpoint.MD]: {
            colSpan: 2,
            rowSpan: 2
        },
        [Breakpoint.LG]: {
            colSpan: 6,
            rowSpan: 3
        }
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const TILE_S_AREA = tileSizeSpaceRegistry[TileSize.S][Breakpoint.LG].colSpan *
    tileSizeSpaceRegistry[TileSize.S][Breakpoint.LG].rowSpan;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const TILE_L_AREA = tileSizeSpaceRegistry[TileSize.L][Breakpoint.LG].colSpan *
    tileSizeSpaceRegistry[TileSize.L][Breakpoint.LG].rowSpan;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const TILE_XL_AREA = tileSizeSpaceRegistry[TileSize.XL][Breakpoint.LG].colSpan *
    tileSizeSpaceRegistry[TileSize.XL][Breakpoint.LG].rowSpan;
/**
 * Registry that binds the `TileVersion` with the applicable `TileSize`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const tileVersionTileSizeRegistry = {
    [TileVersion.S]: TileSize.S,
    [TileVersion.L]: TileSize.L,
    [TileVersion.XL]: TileSize.XL,
    [TileVersion.FourColumns]: TileSize.S,
    [TileVersion.FiveColumns]: TileSize.S
};
